import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowDown, ChevronRight } from "lucide-react";
import { MaskLines } from "./Motion";
import { CallButton } from "./CallButton";

const fade = (d) => ({ initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.8, delay: d, ease: [0.22, 1, 0.36, 1] } });

export const PageHero = ({ eyebrow, icon: Icon, line1, line2, text, image, secondary, crumb, compact = false, testId = "page-hero", children }) => (
  <section data-testid={testId} className={`relative overflow-hidden text-white ${compact ? "py-16 sm:py-20" : "py-20 sm:py-28"}`}>
    {image ? (
      <>
        <img src={image} alt="" className="kenburns absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/90 via-ink/60 to-ink/20" />
      </>
    ) : (
      <div className="absolute inset-0 bg-gradient-to-br from-ink via-[#123d6b] to-brand" />
    )}
    <div className="relative mx-auto max-w-[1320px] px-4 sm:px-8">
      {crumb && (
        <motion.nav {...fade(0)} className="mb-5 flex items-center gap-2 text-sm text-white/85" data-testid="breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link><ChevronRight className="h-3.5 w-3.5" /><span className="font-semibold text-white">{crumb}</span>
        </motion.nav>
      )}
      {eyebrow && (
        <motion.p {...fade(0)} className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-2 text-[11px] font-extrabold uppercase tracking-wide backdrop-blur-sm">
          {Icon && <Icon className="h-4 w-4" />}{eyebrow}
        </motion.p>
      )}
      <MaskLines testId={`${testId}-title`} className="mt-6 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
        lines={[line1, line2 && <span key="l2" className="text-[#FFC2A8]">{line2}</span>].filter(Boolean)} />
      {text && <motion.p {...fade(0.45)} className="mt-6 max-w-xl text-base leading-relaxed text-white/90 sm:text-lg">{text}</motion.p>}
      <motion.div {...fade(0.6)} className="mt-8 flex flex-wrap items-center gap-6">
        <CallButton testId={`${testId}-call`} label="Call now" size="lg" />
        {secondary && (
          <a href={secondary.href} data-testid={`${testId}-secondary`} className="group flex items-center gap-2 border-b border-white/40 pb-1 text-sm font-bold hover:border-white">
            {secondary.label}<ArrowDown className="h-4 w-4 transition-transform group-hover:translate-y-0.5" />
          </a>
        )}
      </motion.div>
      {children}
    </div>
  </section>
);
